import { LoadingIndicator } from '@msaf/core-react'
import { ExportSearchResultsToCsv } from '../../../../../../services/export-utils'

interface ExportSearchResultsProps {
  actionUrl: string
  csrfToken?: string
  actionQuery?: string
  actionLabel: string
}

export default function ExportSearchResults({
  actionUrl,
  csrfToken,
  actionQuery,
  actionLabel,
}: ExportSearchResultsProps) {
  const { requestCsvExportUrl, isLoading } = ExportSearchResultsToCsv(actionUrl, csrfToken, actionQuery)

  if (isLoading) {
    return <LoadingIndicator>Loading&hellip;</LoadingIndicator>
  }
  return (
    <button onClick={() => requestCsvExportUrl()} className='c-dropdown-menu__link'>
      {actionLabel}
    </button>
  )
}
